import { useQuery } from 'react-query';
import { JsonValue } from 'type-fest';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

export type InterrogationRequestData = JsonValue;

export type InterrogationRequestParams = {
  componentId?: number;
};

export type InterrogationRequestQueryKey = readonly [
  'quotes',
  'components',
  InterrogationRequestParams,
  'interrogation_request',
];

export const getInterrogationRequestQueryKey = (
  params: InterrogationRequestParams,
): InterrogationRequestQueryKey => [
  'quotes',
  'components',
  params,
  'interrogation_request',
];

export const useInterrogationRequest: QueryFunction<
  InterrogationRequestData,
  [InterrogationRequestParams],
  InterrogationRequestQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getInterrogationRequestQueryKey(params);
  return useQuery<
    InterrogationRequestData,
    unknown,
    InterrogationRequestData,
    InterrogationRequestQueryKey
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request<InterrogationRequestData>(
        `/quotes/components/${params.componentId}/interrogation_request`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      );
    },
  });
};
